import { useEffect, useRef, useState } from 'react';



const MultiValueDropdown = ({checkBoxData, setIsFilterOpen, filterValue, changeValue}) => {

    const ref = useRef(null);

    const [ selectedValues, setSelectedValues ] = useState([...filterValue]);

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                
                setIsFilterOpen(false);
            }
        }

        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);

    const onChange = (value) => {
        const valueIndex = selectedValues.findIndex( ({value: selectedValue}) => selectedValue === value.value);
        const tempValues = [...selectedValues];
        if(valueIndex > -1) {
            const newValue = tempValues.filter((val ,index) => index !== valueIndex);
            setSelectedValues(newValue);
            changeValue(newValue);
        } else {
            tempValues.push(value);
            setSelectedValues(tempValues);
            changeValue(tempValues);
        }
        
    }

    const isChecked = (checkBoxValue) => {
        const valIndex = selectedValues.findIndex(({value}) => value === checkBoxValue)
        return valIndex > -1;
    }

    return <div ref={ref} className="calendar-dropdown" style={{
            width: '100%', 
            maxHeight: '300px',
            overflow: 'auto',
        }}>
        <div className="d-flex flex-column" style={{gap: '10px'}}>
            {
                checkBoxData.map((data, index) => (<div className="checkbox-container" key={index}>
                    <input 
                        type="checkbox" 
                        value={data.value} 
                        checked={isChecked(data.value)} 
                        onChange={() => onChange(data) }
                    />
                    <strong style={{textTransform: 'capitalize'}}>{data.label}</strong>
                </div>)
                )
            }
        </div>
    </div>
    
}

export default MultiValueDropdown;

